var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_989_1539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.227 14.3223C28.227 13.3706 28.1498 12.4138 27.9852 11.4775H14.78V16.8687H22.342C22.0282 18.6074 21.0199 20.1456 19.5435 21.123V24.621H24.055C26.7043 22.1827 28.227 18.5817 28.227 14.3223Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.78 28.0009C18.5558 28.0009 21.7401 26.7611 24.0602 24.6211L19.5487 21.1231C18.2935 21.977 16.673 22.4606 14.7851 22.4606C11.1327 22.4606 8.0359 19.9965 6.92475 16.6836H2.26923V20.2897C4.64586 25.0172 9.48657 28.0009 14.78 28.0009Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91966 16.6842C6.33322 14.9454 6.33322 13.0626 6.91966 11.3239V7.71777H2.26928C0.283612 11.6737 0.283612 16.3343 2.26928 20.2903L6.91966 16.6842Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.78 5.54127C16.7759 5.51041 18.705 6.26146 20.1505 7.64012L24.1476 3.64305C21.6166 1.26642 18.2575 -0.0402103 14.78 0.000943444C9.48657 0.000943444 4.64586 2.98459 2.26923 7.71728L6.9196 11.3234C8.02561 8.00536 11.1276 5.54127 14.78 5.54127Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_989_1539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.9fc5e103225eb74ef96cf905c7810f97.svg";
export { ForwardRef as ReactComponent };